import { render } from "./CategoryForm.vue?vue&type=template&id=1be183ee&scoped=true"
import script from "./CategoryForm.vue?vue&type=script&lang=js"
export * from "./CategoryForm.vue?vue&type=script&lang=js"

import "./CategoryForm.vue?vue&type=style&index=0&id=1be183ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be183ee"]])

export default __exports__